export default "__VITE_ASSET__zqB2oMy2__"